import React, { useState } from "react";
import InputField from "../../components/InputField/InputField";
import DashboardNavbar from "../../components/Navbar/DashboardNavbar";
import { shipGift } from "../../utils/ApiRequests";
import jblSpeaker from "../../assets/jbl-speaker.png";
import { useHistory, useParams } from "react-router-dom";
import { useToasts } from "react-toast-notifications";

const SendGift = () => {
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [address, setAddress] = useState("");
  const [country, setCountry] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [phone, setPhone] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const { orderId } = useParams();
  const { addToast } = useToasts();
  const history = useHistory();

  const checkInputs = () => {
    if (
      firstname === "" ||
      lastname === "" ||
      address === "" ||
      country === "" ||
      city === "" ||
      state === "" ||
      phone === ""
    ) {
      return false;
    } else {
      return true;
    }
  };

  const clearForm = () => {
    setFirstname("");
    setAddress("");
    setLastname("");
    setPhone("");
    setCountry("");
    setCity("");
    setState("");
  };

  const submitRequest = async () => {
    const formData = {
      first_name: firstname,
      last_name: lastname,
      country: country,
      state: state,
      city: city,
      address: address,
      phone_number: phone,
    };
    try {
      const { data } = await shipGift(orderId, formData);

      console.log(data);
      clearForm();
      addToast("Order marked for delivery", { appearance: "success" });
      setSuccessMessage("Order marked for delivery");
    } catch (error) {
      console.log(error.response);
      addToast("An error occured, ensure you fill the form appropriately.", {
        appearance: "error",
      });
    }
  };

  return (
    <>
      <DashboardNavbar />
      <div className="global-container py-20 my-20">
        <div className="header my-10">
          <h1 className="text-3xl">Your Delivery Details</h1>
          <p>
            Enter the location of where you would like to recieve your gift
            items
          </p>
        </div>

        <div className="account__bank-item-info flex flex-wrap ">
          <div className="mobiles:w-full w-2/3 lg:w-2/3 border-r  p-10 px-2 mb-4 shadow border-gray-200">
            <div className="form-wrapper p-5">
              <div className="flex flex-wrap">
                <div className="mobiles:w-full w-1/2 pr-2">
                  <InputField
                    label="First Name"
                    id="firstname"
                    htmlFor="firstname"
                    placeholder="Enter first name"
                    value={firstname}
                    required
                    handleChange={({ target }) => {
                      setFirstname(target.value);
                    }}
                  />
                </div>
                <div className="mobiles:w-full w-1/2 pr-2">
                  <InputField
                    label="Last Name"
                    id="lastname"
                    htmlFor="lastname"
                    placeholder="Enter last name"
                    value={lastname}
                    required
                    handleChange={(e) => {
                      setLastname(e.target.value);
                    }}
                  />
                </div>
              </div>
              <InputField
                label="Address"
                id="address"
                type="address"
                htmlFor="address"
                placeholder="Enter your address"
                value={address}
                required
                handleChange={(e) => {
                  setAddress(e.target.value);
                }}
              />
              <div className="flex flex-wrap">
                <div className="mobiles:w-full w-1/2 pr-2">
                  <InputField
                    label="City"
                    id="city"
                    htmlFor="city"
                    placeholder="Enter city"
                    value={city}
                    required
                    handleChange={({ target }) => {
                      setCity(target.value);
                    }}
                  />
                </div>
                <div className="mobiles:w-full w-1/2 pr-2">
                  <InputField
                    label="State"
                    id="state"
                    htmlFor="state"
                    placeholder="Enter state"
                    value={state}
                    required
                    handleChange={(e) => {
                      setState(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="flex flex-wrap">
                <div class="mobiles:w-full w-1/2 pr-2 mb-4">
                  <InputField
                    label="Country"
                    id="country"
                    htmlFor="country"
                    placeholder="Enter country"
                    value={country}
                    required
                    handleChange={(e) => {
                      setCountry(e.target.value);
                    }}
                  />
                </div>
                <div class="mobiles:w-full w-1/2 pr-2 mb-4">
                  <InputField
                    label="Phone"
                    id="PhoneNumber"
                    htmlFor="PhoneNumber"
                    placeholder="Enter Phone Number"
                    value={phone}
                    required
                    pattern="^0[0-9]{10}"
                    handleChange={(e) => {
                      setPhone(e.target.value);
                    }}
                  />
                </div>
              </div>

              <button
                type="submit"
                className={`px-8 py-3 text-center text-white rounded bg-sbg-light-green font-medium text-xs focus:outline-none ${
                  !checkInputs() && "btn-disabled"
                }`}
                onClick={() => {
                  console.log("clicked");
                  submitRequest();
                }}
                disabled={!checkInputs()}
              >
                SUBMIT
              </button>
              {successMessage && (
                <h3>
                  <span
                    style={{
                      textDecoration: "underline",
                      color: "blue",
                      cursor: "pointer",
                    }}
                    onClick={() => history.goBack()}
                  >
                    Go back to your orders
                  </span>
                </h3>
              )}
            </div>
          </div>
          <div className="w-1/3 hidden">
            <div className="gift__tracker-card-wrapper mx-10 p-5 rounded-md">
              <h3>Convert 8 items to cash</h3>
              <h1>N65,000</h1>
              <div className="img__items-wrapper my-5">
                <div className="img-box">
                  <img src={jblSpeaker} alt="item-name" />
                </div>
                <div className="img-box">
                  <img src={jblSpeaker} alt="item-name" />
                </div>
                <div className="img-box">
                  <img src={jblSpeaker} alt="item-name" />
                </div>
                <div className="img-box">
                  <img src={jblSpeaker} alt="item-name" />
                </div>
                <div className="img-box">
                  <img src={jblSpeaker} alt="item-name" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SendGift;
